import { uniqueActionType, operationReducer, setValueReducer, createStateLoadingSelector, createStateErrorsSelector, createStateSuccessSelector } from '@industi/ngx-common';
import * as i4 from '@ngrx/store';
import { combineReducers, createFeatureSelector, createSelector, select, StoreModule } from '@ngrx/store';
import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@ngrx/effects';
import { ofType, Effect, EffectsModule } from '@ngrx/effects';
import { __decorate } from 'tslib';
import { map, switchMap, catchError, withLatestFrom, tap } from 'rxjs/operators';
import { timer, of } from 'rxjs';

/** Action types for forgot password */
const LibAuthForgotPasswordActionTypes = {
    request: uniqueActionType('[lib/auth] Forgot password'),
    requestFail: uniqueActionType('[lib/auth] Forgot password fail'),
    requestSuccess: uniqueActionType('[lib/auth] Forgot password success'),
    requestClearErrors: uniqueActionType('[lib/auth] Forgot password clear errors'),
    requestClear: uniqueActionType('[lib/auth] Forgot password clear')
};
/** Auth forgot password action */
class LibAuthForgotPasswordAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthForgotPasswordActionTypes.request;
    }
}
/** Auth forgot password fail action */
class LibAuthForgotPasswordFailAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthForgotPasswordActionTypes.requestFail;
    }
}
/** Auth forgot password success action */
class LibAuthForgotPasswordSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthForgotPasswordActionTypes.requestSuccess;
    }
}
/** Auth forgot password clear errors action */
class LibAuthForgotPasswordClearErrorsAction {
    constructor() {
        this.type = LibAuthForgotPasswordActionTypes.requestClearErrors;
        this.payload = null;
    }
}
/** Auth forgot password clear action */
class LibAuthForgotPasswordClearAction {
    constructor() {
        this.type = LibAuthForgotPasswordActionTypes.requestClear;
        this.payload = null;
    }
}

/** Auth guard action types */
const LibAuthGuardActionTypes = {
    accessTokenReject: uniqueActionType('[lib/auth] Access token guard reject'),
    loginReject: uniqueActionType('[lib/auth] Login guard reject')
};
/** Auth access token guard reject action */
class LibAuthAccessTokenGuardRejectAction {
    constructor() {
        this.type = LibAuthGuardActionTypes.accessTokenReject;
    }
}
/** Auth login guard reject action */
class LibAuthLoginGuardRejectAction {
    constructor() {
        this.type = LibAuthGuardActionTypes.loginReject;
    }
}

/** Auth login action types */
const LibAuthLoginActionTypes = {
    request: uniqueActionType('[lib/auth] Login'),
    requestFail: uniqueActionType('[lib/auth] Login fail'),
    requestSuccess: uniqueActionType('[lib/auth] Login success'),
    requestClearErrors: uniqueActionType('[lib/auth] Login clear errors'),
    requestClear: uniqueActionType('[lib/auth] Login clear')
};
/** Auth login action */
class LibAuthLoginAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthLoginActionTypes.request;
    }
}
/** Auth login errors action */
class LibAuthLoginFailAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthLoginActionTypes.requestFail;
    }
}
/** Auth login success action */
class LibAuthLoginSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthLoginActionTypes.requestSuccess;
    }
}
/** Auth login clear errors action */
class LibAuthLoginClearErrorsAction {
    constructor() {
        this.type = LibAuthLoginActionTypes.requestClearErrors;
        this.payload = null;
    }
}
/** Auth login clear action */
class LibAuthLoginClearAction {
    constructor() {
        this.type = LibAuthLoginActionTypes.requestClear;
        this.payload = null;
    }
}

/** Auth refresh token action types */
const LibAuthRefreshTokenActionTypes = {
    request: uniqueActionType('[lib/auth] Refresh token'),
    requestFail: uniqueActionType('[lib/auth] Refresh token fail'),
    requestSuccess: uniqueActionType('[lib/auth] Refresh token success'),
    requestClearErrors: uniqueActionType('[lib/auth] Refresh token clear errors'),
    requestClear: uniqueActionType('[lib/auth] Refresh token clear')
};
/** Auth refresh token action */
class LibAuthRefreshTokenAction {
    constructor() {
        this.type = LibAuthRefreshTokenActionTypes.request;
        this.payload = null;
    }
}
/** Auth refresh token fail action */
class LibAuthRefreshTokenFailAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthRefreshTokenActionTypes.requestFail;
    }
}
/** Auth refresh token success action */
class LibAuthRefreshTokenSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthRefreshTokenActionTypes.requestSuccess;
    }
}
/** Auth refresh token clear errors action */
class LibAuthRefreshTokenClearErrorsAction {
    constructor() {
        this.type = LibAuthRefreshTokenActionTypes.requestClearErrors;
        this.payload = null;
    }
}
/** Auth refresh token clear action */
class LibAuthRefreshTokenClearAction {
    constructor() {
        this.type = LibAuthRefreshTokenActionTypes.requestClear;
        this.payload = null;
    }
}

/** Auth registration action types */
const LibAuthRegistrationActionTypes = {
    request: uniqueActionType('[lib/auth] Registration'),
    requestFail: uniqueActionType('[lib/auth] Registration fail'),
    requestSuccess: uniqueActionType('[lib/auth] Registration success'),
    requestClearErrors: uniqueActionType('[lib/auth] Registration clear errors'),
    requestClear: uniqueActionType('[lib/auth] Registration clear')
};
/** Auth registration action */
class LibAuthRegistrationAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthRegistrationActionTypes.request;
    }
}
/** Auth registration fail action */
class LibAuthRegistrationFailAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthRegistrationActionTypes.requestFail;
    }
}
/** Auth registration success action */
class LibAuthRegistrationSuccessAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthRegistrationActionTypes.requestSuccess;
    }
}
/** Auth registration clear errors action */
class LibAuthRegistrationClearErrorsAction {
    constructor() {
        this.type = LibAuthRegistrationActionTypes.requestClearErrors;
        this.payload = null;
    }
}
/** Auth registration clear action */
class LibAuthRegistrationClearAction {
    constructor() {
        this.type = LibAuthRegistrationActionTypes.requestClear;
        this.payload = null;
    }
}

/** Set token action types */
const LibAuthSetTokenActionTypes = {
    setValue: uniqueActionType('[lib/auth] Set token')
};
/** Set token action */
class LibAuthSetTokenAction {
    constructor(payload) {
        this.payload = payload;
        this.type = LibAuthSetTokenActionTypes.setValue;
    }
}

var TokenValueTypes;
(function (TokenValueTypes) {
    TokenValueTypes[TokenValueTypes["STRING"] = 0] = "STRING";
    TokenValueTypes[TokenValueTypes["NUMBER"] = 1] = "NUMBER";
})(TokenValueTypes || (TokenValueTypes = {}));
/** Auth helper class with utils */
class LibAuthUtil {
    /** Cache storage with token data */
    static get storage() {
        return localStorage;
    }
    /**
     * Token setter
     *
     * Parses token response and stores it in the application cache storage
     */
    static set token(token) {
        if (token) {
            Object.keys(token).forEach((key) => {
                if (typeof token[key] !== 'undefined') {
                    LibAuthUtil.storage.setItem(key, token[key].toString());
                }
                else {
                    LibAuthUtil.storage.removeItem(key);
                }
            });
        }
        else {
            LibAuthUtil.tokenDataKeys.forEach((fieldConfig) => {
                LibAuthUtil.storage.removeItem(fieldConfig.key);
            });
        }
    }
    /**
     * Token getter
     *
     * Build and return token response from cached token properties in application store
     */
    static get token() {
        if (!LibAuthUtil.checkTokenValidity()) {
            return null;
        }
        return this.tokenDataKeys.reduce((result, fieldConfig) => {
            let currValue = null;
            switch (fieldConfig.type) {
                case TokenValueTypes.NUMBER:
                    const value = +LibAuthUtil.storage.getItem(fieldConfig.key);
                    currValue = isNaN(value) ? null : value;
                    break;
                case TokenValueTypes.STRING:
                default:
                    currValue = LibAuthUtil.storage.getItem(fieldConfig.key);
            }
            return Object.assign(Object.assign({}, result), { [fieldConfig.key]: currValue });
        }, {});
    }
    /** Checks cached application properties validity */
    static checkTokenValidity() {
        return this.tokenDataKeys
            .map((config) => this.storage.getItem(config.key))
            .find((item) => item === null || typeof item === 'undefined') !== null;
    }
}
/** List of token's fields for mapping from token response to application storage cache */
LibAuthUtil.tokenDataKeys = [
    { key: 'access_token', type: TokenValueTypes.STRING },
    { key: 'expires_in', type: TokenValueTypes.NUMBER },
    { key: 'scope', type: TokenValueTypes.STRING },
    { key: 'token_type', type: TokenValueTypes.STRING },
    { key: 'refresh_token', type: TokenValueTypes.STRING },
    { key: 'refresh_expires_in', type: TokenValueTypes.NUMBER },
    { key: 'session_state', type: TokenValueTypes.STRING }
];

const rootReducerKey = 'libAuth';
const LIB_AUTH_REDUCER_TOKEN = new InjectionToken(rootReducerKey);
/** Initial state of Auth store */
const initialState = {
    login: {},
    refreshToken: {},
    registration: {},
    forgotPassword: {},
    token: LibAuthUtil.token
};
/** Auth reducer */
const reducer = combineReducers({
    login: operationReducer(LibAuthLoginActionTypes),
    refreshToken: operationReducer(LibAuthRefreshTokenActionTypes),
    registration: operationReducer(LibAuthRegistrationActionTypes),
    forgotPassword: operationReducer(LibAuthForgotPasswordActionTypes),
    token: setValueReducer({ types: LibAuthSetTokenActionTypes })
}, initialState);
/** Auth reducer provider for injecting into application */
const libAuthReducerProvider = { provide: LIB_AUTH_REDUCER_TOKEN, useFactory: getReducers };
function getReducers() {
    return reducer;
}
const getState = createFeatureSelector(rootReducerKey);
/** Selector for auth login state */
const getLibAuthLogin = createSelector(getState, (state) => state.login);
/** Selector for auth refresh token state */
const getLibAuthRefreshTokenState = createSelector(getState, (state) => state.refreshToken);
/** Selector for auth registration state */
const getLibAuthRegistration = createSelector(getState, (state) => state.registration);
/** Selector for auth forgot password state */
const getLibAuthForgotPassword = createSelector(getState, (state) => state.forgotPassword);
/** Selector for auth token state */
const getLibAuthToken = createSelector(getState, (state) => state && state.token);
/** Selector for stored access token */
const getLibAuthAccessToken = createSelector(getLibAuthToken, (state) => state && state.access_token);
/** Selector for stored refresh token */
const getLibAuthRefreshToken = createSelector(getLibAuthToken, (state) => state && state.refresh_token);

/** selector for auth forgot password loading state */
const getLibAuthForgotPasswordLoading = createStateLoadingSelector(getLibAuthForgotPassword);
/** selector for auth forgot password errors state */
const getLibAuthForgotPasswordErrors = createStateErrorsSelector(getLibAuthForgotPassword);
/** selector for auth forgot password success state */
const getLibAuthForgotPasswordSuccess = createStateSuccessSelector(getLibAuthForgotPassword);

/** selector for auth login loading state */
const getLibAuthLoginLoading = createStateLoadingSelector(getLibAuthLogin);
/** selector for auth login errors state */
const getLibAuthLoginErrors = createStateErrorsSelector(getLibAuthLogin);
/** selector for auth login success state */
const getLibAuthLoginSuccess = createStateSuccessSelector(getLibAuthLogin);

/** selector for auth refresh token loading state */
const getLibAuthRefreshTokenLoading = createStateLoadingSelector(getLibAuthRefreshTokenState);
/** selector for auth refresh token errors state */
const getLibAuthRefreshTokenErrors = createStateErrorsSelector(getLibAuthRefreshTokenState);
/** selector for auth refresh token success state */
const getLibAuthRefreshTokenSuccess = createStateSuccessSelector(getLibAuthRefreshTokenState);

/** selector for auth registration loading state */
const getLibAuthRegistrationLoading = createStateLoadingSelector(getLibAuthRegistration);
/** selector for auth registration errors state */
const getLibAuthRegistrationErrors = createStateErrorsSelector(getLibAuthRegistration);
/** selector for auth registration success state */
const getLibAuthRegistrationSuccess = createStateSuccessSelector(getLibAuthRegistration);

/** Auth service base class */
class LibAuthService {
}

/**
 * Server timeout in seconds
 *
 * Default value is 15
 */
const LibAuthDefaultTimeoutTime = new InjectionToken('auth-timeout-time');

class LibAuthTokenRefreshService {
    constructor(timeoutTime) {
        this.timeoutTime = timeoutTime;
    }
    /**
     * Run callback earlier by provided DI LibAuthDefaultTimeoutTime before token expires
     *
     * Recommended to use LibAuthDefaultTimeoutTime set to server timeout time
     */
    refreshOn(expiresIn, callback) {
        if (!!LibAuthTokenRefreshService.refreshSub) {
            LibAuthTokenRefreshService.refreshSub.unsubscribe();
        }
        LibAuthTokenRefreshService.refreshSub = timer((expiresIn - this.timeoutTime) * 1000).subscribe(callback);
    }
    /** Stops refresher */
    stop() {
        if (!!LibAuthTokenRefreshService.refreshSub) {
            LibAuthTokenRefreshService.refreshSub.unsubscribe();
        }
    }
}
LibAuthTokenRefreshService.ɵfac = function LibAuthTokenRefreshService_Factory(t) { return new (t || LibAuthTokenRefreshService)(i0.ɵɵinject(LibAuthDefaultTimeoutTime)); };
LibAuthTokenRefreshService.ɵprov = i0.ɵɵdefineInjectable({ token: LibAuthTokenRefreshService, factory: LibAuthTokenRefreshService.ɵfac });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LibAuthTokenRefreshService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LibAuthDefaultTimeoutTime]
            }] }]; }, null); })();

class LibAuthEffects {
    constructor(actions$, service, refreshService, store) {
        this.actions$ = actions$;
        this.service = service;
        this.refreshService = refreshService;
        this.store = store;
        this.login$ = this.actions$.pipe(ofType(LibAuthLoginActionTypes.request), map((action) => action.payload), switchMap((payload) => this.service.login(payload.data).pipe(map((res) => new LibAuthLoginSuccessAction({ res })), catchError((errors) => of(new LibAuthLoginFailAction({ errors }))))));
        this.refreshToken$ = this.actions$.pipe(ofType(LibAuthRefreshTokenActionTypes.request), withLatestFrom(this.store.pipe(select(getLibAuthRefreshToken))), switchMap(([action, refreshToken]) => this.service.refreshToken(refreshToken).pipe(map((res) => new LibAuthRefreshTokenSuccessAction({ res })), catchError((errors) => of(new LibAuthRefreshTokenFailAction({ errors }))))));
        this.registration$ = this.actions$.pipe(ofType(LibAuthRegistrationActionTypes.request), map((action) => action.payload), switchMap((payload) => this.service.registration(payload.data).pipe(map((res) => new LibAuthRegistrationSuccessAction({ res })), catchError((errors) => of(new LibAuthRegistrationFailAction({ errors }))))));
        this.forgotPassword$ = this.actions$.pipe(ofType(LibAuthForgotPasswordActionTypes.request), map((action) => action.payload), switchMap((payload) => this.service.forgotPassword(payload.data).pipe(map((res) => new LibAuthForgotPasswordSuccessAction({ res })), catchError((errors) => of(new LibAuthForgotPasswordFailAction({ errors }))))));
        this.loginSuccess$ = this.actions$.pipe(ofType(LibAuthLoginActionTypes.requestSuccess), map((action) => action.payload.res), tap((value) => {
            this.refreshService.refreshOn(value.expires_in, () => {
                this.store.dispatch(new LibAuthRefreshTokenAction());
            });
        }), map((value) => new LibAuthSetTokenAction({ value })));
        this.refreshTokenSuccess$ = this.actions$.pipe(ofType(LibAuthRefreshTokenActionTypes.requestSuccess), map((action) => action.payload.res), tap((value) => {
            this.refreshService.refreshOn(value.expires_in, () => {
                this.store.dispatch(new LibAuthRefreshTokenAction());
            });
        }), map((value) => new LibAuthSetTokenAction({ value })));
        this.setToken$ = this.actions$.pipe(ofType(LibAuthSetTokenActionTypes.setValue), map((action) => action.payload.value), tap((token) => {
            LibAuthUtil.token = token;
            if (!token) {
                this.refreshService.stop();
            }
        }));
    }
}
LibAuthEffects.ɵfac = function LibAuthEffects_Factory(t) { return new (t || LibAuthEffects)(i0.ɵɵinject(i1.Actions), i0.ɵɵinject(LibAuthService), i0.ɵɵinject(LibAuthTokenRefreshService), i0.ɵɵinject(i4.Store)); };
LibAuthEffects.ɵprov = i0.ɵɵdefineInjectable({ token: LibAuthEffects, factory: LibAuthEffects.ɵfac });
__decorate([
    Effect()
], LibAuthEffects.prototype, "login$", void 0);
__decorate([
    Effect()
], LibAuthEffects.prototype, "refreshToken$", void 0);
__decorate([
    Effect()
], LibAuthEffects.prototype, "registration$", void 0);
__decorate([
    Effect()
], LibAuthEffects.prototype, "forgotPassword$", void 0);
__decorate([
    Effect()
], LibAuthEffects.prototype, "loginSuccess$", void 0);
__decorate([
    Effect()
], LibAuthEffects.prototype, "refreshTokenSuccess$", void 0);
__decorate([
    Effect({ dispatch: false })
], LibAuthEffects.prototype, "setToken$", void 0);
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LibAuthEffects, [{
        type: Injectable
    }], function () { return [{ type: i1.Actions }, { type: LibAuthService }, { type: LibAuthTokenRefreshService }, { type: i4.Store }]; }, { login$: [], refreshToken$: [], registration$: [], forgotPassword$: [], loginSuccess$: [], refreshTokenSuccess$: [], setToken$: [] }); })();

class LibAuthEffectsModule {
}
LibAuthEffectsModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibAuthEffectsModule });
LibAuthEffectsModule.ɵinj = i0.ɵɵdefineInjector({ factory: function LibAuthEffectsModule_Factory(t) { return new (t || LibAuthEffectsModule)(); }, providers: [
        { provide: LibAuthDefaultTimeoutTime, useValue: 15 },
        LibAuthTokenRefreshService
    ], imports: [[
            EffectsModule.forFeature([
                LibAuthEffects
            ])
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibAuthEffectsModule, { imports: [i1.EffectsFeatureModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LibAuthEffectsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    EffectsModule.forFeature([
                        LibAuthEffects
                    ])
                ],
                providers: [
                    { provide: LibAuthDefaultTimeoutTime, useValue: 15 },
                    LibAuthTokenRefreshService
                ]
            }]
    }], null, null); })();

class LibAuthStateModule {
}
LibAuthStateModule.ɵmod = i0.ɵɵdefineNgModule({ type: LibAuthStateModule });
LibAuthStateModule.ɵinj = i0.ɵɵdefineInjector({ factory: function LibAuthStateModule_Factory(t) { return new (t || LibAuthStateModule)(); }, providers: [
        libAuthReducerProvider
    ], imports: [[
            StoreModule.forFeature(rootReducerKey, LIB_AUTH_REDUCER_TOKEN)
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LibAuthStateModule, { imports: [i4.StoreFeatureModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LibAuthStateModule, [{
        type: NgModule,
        args: [{
                imports: [
                    StoreModule.forFeature(rootReducerKey, LIB_AUTH_REDUCER_TOKEN)
                ],
                providers: [
                    libAuthReducerProvider
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { LIB_AUTH_REDUCER_TOKEN, LibAuthAccessTokenGuardRejectAction, LibAuthEffectsModule, LibAuthForgotPasswordAction, LibAuthForgotPasswordActionTypes, LibAuthForgotPasswordClearAction, LibAuthForgotPasswordClearErrorsAction, LibAuthForgotPasswordFailAction, LibAuthForgotPasswordSuccessAction, LibAuthGuardActionTypes, LibAuthLoginAction, LibAuthLoginActionTypes, LibAuthLoginClearAction, LibAuthLoginClearErrorsAction, LibAuthLoginFailAction, LibAuthLoginGuardRejectAction, LibAuthLoginSuccessAction, LibAuthRefreshTokenAction, LibAuthRefreshTokenActionTypes, LibAuthRefreshTokenClearAction, LibAuthRefreshTokenClearErrorsAction, LibAuthRefreshTokenFailAction, LibAuthRefreshTokenSuccessAction, LibAuthRegistrationAction, LibAuthRegistrationActionTypes, LibAuthRegistrationClearAction, LibAuthRegistrationClearErrorsAction, LibAuthRegistrationFailAction, LibAuthRegistrationSuccessAction, LibAuthService, LibAuthSetTokenAction, LibAuthSetTokenActionTypes, LibAuthStateModule, LibAuthUtil, getLibAuthAccessToken, getLibAuthForgotPassword, getLibAuthForgotPasswordErrors, getLibAuthForgotPasswordLoading, getLibAuthForgotPasswordSuccess, getLibAuthLogin, getLibAuthLoginErrors, getLibAuthLoginLoading, getLibAuthLoginSuccess, getLibAuthRefreshToken, getLibAuthRefreshTokenErrors, getLibAuthRefreshTokenLoading, getLibAuthRefreshTokenState, getLibAuthRefreshTokenSuccess, getLibAuthRegistration, getLibAuthRegistrationErrors, getLibAuthRegistrationLoading, getLibAuthRegistrationSuccess, getLibAuthToken, getReducers, libAuthReducerProvider, rootReducerKey };
//# sourceMappingURL=app-store-auth.js.map
